import type { TimelineViewTransform } from "../ViewTransform/transform";

export interface ManualPanGate {
  getAllowPanDrag: () => boolean;
  /** True when a pan should leave follow mode and keep the new view. */
  getLockedPan: () => boolean;
  onLockedPan?: (next: TimelineViewTransform) => void;
  setView: (next: TimelineViewTransform) => void;
}

export function canPan(options: ManualPanGate): boolean {
  return options.getAllowPanDrag() || options.getLockedPan();
}

export function publishPan(
  options: ManualPanGate,
  next: TimelineViewTransform,
): void {
  if (options.onLockedPan !== undefined) {
    options.onLockedPan(next);
    return;
  }
  options.setView(next);
}
